module.exports = __webpack_public_path__ + "media/smart_sales/step-5-36366604.svg";